<template>
<b-container v-if="articles.id" class="py-3 px-0">
    <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent" v-html="articles.title.rendered"></b-card>
    <b-card class="shadow px-0 pt-1 pb-4 rounded bg-transparent">
        <b-card-img v-if="articles.uagb_featured_image_src" :src="articles.uagb_featured_image_src.full[0]" class="pb-2"></b-card-img>
        <b-card-text v-html="html"></b-card-text>
        <!-- The Modal -->
<div id="myModal" class="modal">

  <!-- The Close Button -->
  <span class="close">&times;</span>

  <!-- Modal Content (The Image) -->
  <img class="modal-content" id="img01">

  <!-- Modal Caption (Image Text) -->
  <div id="caption"></div>
</div>
        <b-card-text text-tag="span">Autor: </b-card-text>
        <b-card-text text-tag="span" v-html="articles.uagb_author_info.display_name" class="autor_articol"></b-card-text>
        <div>
        <b-card-text text-tag="span">Data: </b-card-text>
        <b-card-text text-tag="span" class="autor_articol">{{articles.date | moment("DD.MM.YYYY")}}</b-card-text>
        </div>
    </b-card>
</b-container>
</template>

<script>
import gallery from 'img-vuer'
import Vue from 'vue'
Vue.use(require('vue-moment'));

Vue.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: true, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true, // preload images in the same group, default true
})



export default {
    data() {
        return {
            articles: {},
            html: '',
            dataarticol : ''
        };
    },
    methods: {

        loadPosts() {
            fetch('https://bibliotecaarad.ro/wp-json/wp/v2/posts/' + this.$route.params.id)
                .then(response => response.json())
                .then(data => {this.articles = data; 
                this.html = data.content.rendered;
                this.dataarticol = data.date;
                var regex = new RegExp(/class="(.*?)"/, 'g');
                var regexb = new RegExp(/<iframe/, 'g');
                var regexc = new RegExp(/<\/iframe>/, 'g');
                this.html = data.content.rendered.replace(regex, '').replace(regexb,'<div class="wrapper"><iframe').replace(regexc,'<iframe></div>');

                //.replace(/class="(.*?)"/g,'');
                });
        }
    },
    created() {
        this.loadPosts();
  
    }
};
</script>

<style lang="scss" scoped>
.autor_articol {
    font-weight: 600;
    font-size: 1.1rem;
}
</style>
